<template>
  <div>
    <h2>Paso 3: Confirmar y realizar el pago</h2>
    <form @submit.prevent="confirmarPago">
      <input v-model="tarjeta" placeholder="Número de Tarjeta" />
      <input v-model="expiracion" placeholder="Expiración (MM/AA)" />
      <input v-model="cvv" placeholder="CVV" />
      <button type="submit">Pagar</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tarjeta: '',
      expiracion: '',
      cvv: '',
    };
  },
  methods: {
    confirmarPago() {
      console.log('Pago confirmado');
      // Lógica de envío al backend
    },
  },
};
</script>
